import React, { useState } from 'react';
import ButtonComponent from '../../../atoms/Button/Button';
import Input from '../../../atoms/Input/Input';
import images from '../../../../app/utlis/image';
import { useLocation } from 'react-router-dom';
import { showSuccessToast, validatePhoneNumber } from '../../../../app/helper/functions';
import submitToSheet from '../../../../app/utlis/submitToSheet';
import { trackClarityEvent } from '../../../../app/utlis/ClarityAnalytics';
import { trackFirebaseEvent } from '../../../../app/utlis/FirebaseAnalytics';
import { CLARITY_EVENTS } from '../../../../app/utlis/EventTypes';
import { motion } from 'framer-motion';

const CallbackForm = () => {
  const location = useLocation();
  const path = location.pathname;

  const [formData, setFormData] = useState({
    FirstName: '',
    PhoneNumber: '',
    Message: '',
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onChangeForm = (e: any) => {
    const { value, name } = e.target;
    setErrorMessage('');
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async () => {
    if (!formData.FirstName || !validatePhoneNumber(formData.PhoneNumber)) {
      setErrorMessage('Please fill out all fields correctly');
      return;
    }
  
    try {
      setLoading(true);

      const payload = {
        source: path === '/contactus' ? 'contact_us_page' : 'callback_form',
        page: path,
      };
      trackClarityEvent(CLARITY_EVENTS.GET_IN_TOUCH_CLICKED, payload);
      trackFirebaseEvent(CLARITY_EVENTS.GET_IN_TOUCH_CLICKED, payload);

      await submitToSheet({
        source: path === '/contactus' ? 'Contact Us' : 'Compliance Call',
        name: formData.FirstName,
        mobileNo: formData.PhoneNumber,
        message: formData.Message,
      });
      
  
      setFormData({
        FirstName: '',
        PhoneNumber: '',
        Message: '',
      });
  
      showSuccessToast(
        'Thank you for showing interest in Sattva Tech, We will contact you soon.'
      );
    } catch (error) {
      console.error(error);
      setErrorMessage('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className={`${path === '/contactus' ? '' : 'pb-16 md:pb-32'}`}>
      <div className="w-full flex flex-col md:flex-row items-center pt-16 justify-center bg-darkGreyPrimary gap-6">
        <motion.img
          src={images.CONTACTFORM}
          className="hidden md:block w-4/12"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
        />

    <div className="bg-blackDark  w-full  md:w-1/2  h-auto px-4 py-6 sm:px-8 sm:py-10 md:px-12 md:py-5 lg:px-12 lg:py-10 xl:px-20 xl:py-24">
      <Input
  type="text"
  name="FirstName"
  value={formData.FirstName}
  onChangeForm={onChangeForm}
  placeholder="Name"
/>


          <Input
            name="PhoneNumber"
            value={formData.PhoneNumber}
            onChangeForm={(e: any) => {
              if (/^\d{0,10}$/.test(e.target.value)) onChangeForm(e);
            }}
            placeholder="Phone Number"
            type="tel"
          />

          <textarea
            name="Message"
            value={formData.Message}
            onChange={onChangeForm}
            placeholder="Message"
            className="w-full p-4 h-48 bg-darkGreyPrimary"
          />

          {errorMessage && (
            <div className="text-red-500 mt-2">{errorMessage}</div>
          )}

          {!loading ? (
            <ButtonComponent
              label="Get a Callback"
              className="bg-yellow w-full h-10 md:h-16 mt-4"
              onClick={onSubmit}
            />
          ) : (
            <div className="loader mt-4" />
          )}
        </div>
      </div>
    </div>
  );
};

export default CallbackForm;
